import QuestionValue from "./QuestionValue";

export default class QuestionValueBooleanShape extends QuestionValue{
    constructor(value, texture) {
        super(value);
        this._texture = texture;
    }

    get texture(){
    	return this._texture;
	}
}